import arbitrum from '@/plugins/arbitrum'
import arbitrumNova from '@/plugins/arbitrumNova'
import avalanche from '@/plugins/avalanche'
import base from '@/plugins/base'
import bitcoin from '@/plugins/bitcoin'
import bitcoincash from '@/plugins/bitcoincash'
import bnbsmartchain from '@/plugins/bnbsmartchain'
import cosmos from '@/plugins/cosmos'
import dogecoin from '@/plugins/dogecoin'
import ethereum from '@/plugins/ethereum'
import gnosis from '@/plugins/gnosis'
import litecoin from '@/plugins/litecoin'
import mayachain from '@/plugins/mayachain'
import mobile from '@/plugins/mobile'
import optimism from '@/plugins/optimism'
import polygon from '@/plugins/polygon'
import solana from '@/plugins/solana'
import thorchain from '@/plugins/thorchain'
import tron from '@/plugins/tron'
import walletConnectToDapps from '@/plugins/walletConnectToDapps'

export const activePlugins = [
  arbitrum,
  arbitrumNova,
  avalanche,
  base,
  bitcoin,
  bitcoincash,
  bnbsmartchain,
  cosmos,
  dogecoin,
  ethereum,
  gnosis,
  litecoin,
  mayachain,
  mobile,
  optimism,
  polygon,
  solana,
  thorchain,
  tron,
  walletConnectToDapps,
]
